// extracted by mini-css-extract-plugin
module.exports = {"csv-preview":"csv-preview___3DcWS","total":"total___1bTfI"};